(function() {
    'use strict';

    angular.module('swif.publicLightning')
        .factory('swifPublicLightningService', swifPublicLightningService);

    function swifPublicLightningService($q, swifFrameworkService,
        swifPublicLightningConstant, swifInterventionsService,
        swifPatrimoineService, taskService, swifOpenbaseCompanyService) {

        'ngInject';
        var patrimoine_contract = swifPatrimoineService.contract;
        var swif = swifFrameworkService;
        var constant = swifPublicLightningConstant;
        var openstc = swifInterventionsService;
        var patrimoine = swifPatrimoineService;
        var service = angular.copy(constant);
        service.intervention = {};
        service.request = {};
        service.planning = {};
        service.patrimoine = {};
        service.configuration = {};
        service.tasks = taskService;

        service.request.resolveData = function () {
            return swif.route.check().then(function () {
                var data = {};
                data.title = 'Demandes';
                data.actionViewsCategory = 'publicLightningViews';
                data.preModal = service.request.preModal;
                data.callback = openstc.request.callback;
                data.preValidate = openstc.request.preValidate;

                var deferred = $q.defer();

                var filter = {};
                filter.fields = openstc.request.COLLECTION_FIELDS;
                swif.data.addExtraFilter(filter, 'is_public_lightning', '|');
                swif.data.addExtraFilter(filter, 'is_public_lightning', '|');
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'service_id.is_public_lightning', '=', true);
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'is_public_lightning', '=', true);
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'equipment_id.categ_id.is_streetlight', '=', true);
                swif.data.sortOn(filter, 'id', 'DESC');

                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {

                    var default_states = company.state_default_filters;
                    if (!default_states) {
                        default_states = ['valid', 'wait', 'to_confirm'];
                    }
                    swif.data.addFilter(filter, 'state', 'in', default_states);

                    swif.collections.createOrUpdate(
                        'requests',
                        'intervention_request',
                        filter
                    ).then(function (collection) {
                        data.requests = collection;
                        deferred.resolve(data);
                    });
                });

                return deferred.promise;
            });
        };

        service.request.preModal = function (data) {
            openstc.request.preModal(data);
            if (data.action.id === 'add') {
                data.model._display_equipment_id = true;
            }
        };

        service.planning.resolveData = function () {
            return openstc.planning.resolveData();
        };
        service.intervention.resolveData = function () {
            return swif.route.check().then(function () {
                var data = {};
                data.title = 'Interventions';
                data.actionViewsCategory = 'publicLightningViews';
                data.preModal = service.intervention.preModal;
                data.callback = openstc.intervention.callback;
                data.preValidate = openstc.intervention.preValidate;
                var filter = openstc.intervention.getFilter();
                swif.data.addExtraFilter(filter, 'is_public_lightning', '|');
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'service_id.is_public_lightning', '=', true);
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'ask_id.is_public_lightning', '=', true);
                swif.data.sortOn(filter, 'id', 'DESC');
                return swif.collections.createOrUpdate(
                    'interventions',
                    'intervention',
                    filter
                ).then(function (collection) {
                    data.interventions = collection;
                    return data;
                });
            });


        };
        service.intervention.createCollections = function () {
            var filter = {};
            filter.fields = ['id', 'name', 'description', 'site1', 'site_details', 'service_id', 'manager_id', 'partner_id', 'partner_address', 'create_date', 'write_uid', 'state', 'actions'];
            swif.data.addFilter(filter, 'state', 'in', ['valid', 'wait', 'to_confirm', 'dst']);
            swif.data.addExtraFilter(filter, 'is_streetlight', 'equipment_id.categ_id.is_streetlight', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            var promises = [];
            promises.push(swif.collections.createOrUpdate(
                'requests',
                'intervention_request',
                filter
            ));
            filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['open', 'scheduled', 'pending']);
            swif.data.addExtraFilter(filter, 'is_streetlight', 'equipment_id.categ_id.is_streetlight', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            promises.push(swif.collections.createOrUpdate(
                'interventions',
                'intervention',
                filter
            ));
            filter = {};
            swif.data.addFilter(
                filter,
                'state', 'in', ['draft', 'open']
            );
            swif.data.addExtraFilter(filter, 'is_streetlight', 'project_id.equipment_id.categ_id.is_streetlight', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            promises.push(swif.collections.createOrUpdate(
                'tasks',
                'task',
                filter
            ));
            return $q.all(promises);
        };
        service.patrimoine.resolveReferentielData = function () {
            return swif.route.check({resources: ['d3']}).then(function () {
                var deferred = $q.defer();
                var data = {};
                data.patrimoine_type = 'patrimoine_equipment';
                data.title = 'Référentiel patrimonial';
                var filter = patrimoine.referentiel.getCollectionFilter(data.patrimoine_type);
                swif.data.addFilter(filter, 'categ_id.is_streetlight', '=', true);
                patrimoine.referentiel.createCollection(data.patrimoine_type, filter)
                .then(function (collection) {
                    data.referentiel = collection;
                    patrimoine.referentiel.data.referentiel = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };
        service.patrimoine.resolveContractsData = function () {
            return swif.route.check().then(function () {
                var deferred = $q.defer();
                var data = {};
                data.title = 'Controls-Contracts';
                var filter = {};
                swif.data.addExtraFilter(filter, 'is_public_lightning', 'service_id.is_public_lightning', '=', true);
                patrimoine_contract.createCollection(filter).then(function (collection) {
                    data.contracts = collection;
                    patrimoine.referentiel.data.contracts = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };
        return service;
    }
})();
